export const baseConsonants = [
  { base: 'ሀ', family: ['ሀ', 'ሁ', 'ሂ', 'ሃ', 'ሄ', 'ህ', 'ሆ'], sound: 'ha' },
  { base: 'ለ', family: ['ለ', 'ሉ', 'ሊ', 'ላ', 'ሌ', 'ል', 'ሎ'], sound: 'le' },
  { base: 'ሐ', family: ['ሐ', 'ሑ', 'ሒ', 'ሓ', 'ሔ', 'ሕ', 'ሖ'], sound: 'hhe' },
  { base: 'መ', family: ['መ', 'ሙ', 'ሚ', 'ማ', 'ሜ', 'ም', 'ሞ'], sound: 'me' },
  { base: 'ሠ', family: ['ሠ', 'ሡ', 'ሢ', 'ሣ', 'ሤ', 'ሥ', 'ሦ'], sound: 'se' },
  { base: 'ረ', family: ['ረ', 'ሩ', 'ሪ', 'ራ', 'ሬ', 'ር', 'ሮ'], sound: 're' },
  { base: 'ሰ', family: ['ሰ', 'ሱ', 'ሲ', 'ሳ', 'ሴ', 'ስ', 'ሶ'], sound: 'se' },
  { base: 'ሸ', family: ['ሸ', 'ሹ', 'ሺ', 'ሻ', 'ሼ', 'ሽ', 'ሾ'], sound: 'she' },
  { base: 'ቀ', family: ['ቀ', 'ቁ', 'ቂ', 'ቃ', 'ቄ', 'ቅ', 'ቆ'], sound: 'qe' },
  { base: 'በ', family: ['በ', 'ቡ', 'ቢ', 'ባ', 'ቤ', 'ብ', 'ቦ'], sound: 'be' },
  { base: 'ቨ', family: ['ቨ', 'ቩ', 'ቪ', 'ቫ', 'ቬ', 'ቭ', 'ቮ'], sound: 've' },
  { base: 'ተ', family: ['ተ', 'ቱ', 'ቲ', 'ታ', 'ቴ', 'ት', 'ቶ'], sound: 'te' },
  { base: 'ቸ', family: ['ቸ', 'ቹ', 'ቺ', 'ቻ', 'ቼ', 'ች', 'ቾ'], sound: 'che' },
  { base: 'ኀ', family: ['ኀ', 'ኁ', 'ኂ', 'ኃ', 'ኄ', 'ኅ', 'ኆ'], sound: 'hhe' },
  { base: 'ነ', family: ['ነ', 'ኑ', 'ኒ', 'ና', 'ኔ', 'ን', 'ኖ'], sound: 'ne' },
  { base: 'ኘ', family: ['ኘ', 'ኙ', 'ኚ', 'ኛ', 'ኜ', 'ኝ', 'ኞ'], sound: 'nye' },
  { base: 'አ', family: ['አ', 'ኡ', 'ኢ', 'ኣ', 'ኤ', 'እ', 'ኦ'], sound: 'a' },
  { base: 'ከ', family: ['ከ', 'ኩ', 'ኪ', 'ካ', 'ኬ', 'ክ', 'ኮ'], sound: 'ke' },
  { base: 'ኸ', family: ['ኸ', 'ኹ', 'ኺ', 'ኻ', 'ኼ', 'ኽ', 'ኾ'], sound: 'khe' },
  { base: 'ወ', family: ['ወ', 'ዉ', 'ዊ', 'ዋ', 'ዌ', 'ው', 'ዎ'], sound: 'we' },
  { base: 'ዐ', family: ['ዐ', 'ዑ', 'ዒ', 'ዓ', 'ዔ', 'ዕ', 'ዖ'], sound: 'a' },
  { base: 'ዘ', family: ['ዘ', 'ዙ', 'ዚ', 'ዛ', 'ዜ', 'ዝ', 'ዞ'], sound: 'ze' },
  { base: 'ዠ', family: ['ዠ', 'ዡ', 'ዢ', 'ዣ', 'ዤ', 'ዥ', 'ዦ'], sound: 'zhe' },
  { base: 'የ', family: ['የ', 'ዩ', 'ዪ', 'ያ', 'ዬ', 'ይ', 'ዮ'], sound: 'ye' },
  { base: 'ደ', family: ['ደ', 'ዱ', 'ዲ', 'ዳ', 'ዴ', 'ድ', 'ዶ'], sound: 'de' },
  { base: 'ጀ', family: ['ጀ', 'ጁ', 'ጂ', 'ጃ', 'ጄ', 'ጅ', 'ጆ'], sound: 'je' },
  { base: 'ገ', family: ['ገ', 'ጉ', 'ጊ', 'ጋ', 'ጌ', 'ግ', 'ጎ'], sound: 'ge' },
  { base: 'ጠ', family: ['ጠ', 'ጡ', 'ጢ', 'ጣ', 'ጤ', 'ጥ', 'ጦ'], sound: 'te' },
  { base: 'ጨ', family: ['ጨ', 'ጩ', 'ጪ', 'ጫ', 'ጬ', 'ጭ', 'ጮ'], sound: 'che' },
  { base: 'ጰ', family: ['ጰ', 'ጱ', 'ጲ', 'ጳ', 'ጴ', 'ጵ', 'ጶ'], sound: 'pe' },
  { base: 'ጸ', family: ['ጸ', 'ጹ', 'ጺ', 'ጻ', 'ጼ', 'ጽ', 'ጾ'], sound: 'tse' },
  { base: 'ፀ', family: ['ፀ', 'ፁ', 'ፂ', 'ፃ', 'ፄ', 'ፅ', 'ፆ'], sound: 'tse' },
  { base: 'ፈ', family: ['ፈ', 'ፉ', 'ፊ', 'ፋ', 'ፌ', 'ፍ', 'ፎ'], sound: 'fe' },
  { base: 'ፐ', family: ['ፐ', 'ፑ', 'ፒ', 'ፓ', 'ፔ', 'ፕ', 'ፖ'], sound: 'pe' }
];

export const ethiopicNumerals = [
  { symbol: '፩', value: 1, name: 'and' },
  { symbol: '፪', value: 2, name: 'hulet' },
  { symbol: '፫', value: 3, name: 'sost' },
  { symbol: '፬', value: 4, name: 'arat' },
  { symbol: '፭', value: 5, name: 'amest' },
  { symbol: '፮', value: 6, name: 'sedest' },
  { symbol: '፯', value: 7, name: 'sebat' },
  { symbol: '፰', value: 8, name: 'semanya' },
  { symbol: '፱', value: 9, name: 'zetegna' },
  { symbol: '፲', value: 10, name: 'aser' },
  { symbol: '፳', value: 20, name: 'haya' },
  { symbol: '፴', value: 30, name: 'selasa' },
  { symbol: '፵', value: 40, name: 'arba' },
  { symbol: '፶', value: 50, name: 'hamsa' },
  { symbol: '፷', value: 60, name: 'silsa' },
  { symbol: '፸', value: 70, name: 'seba' },
  { symbol: '፹', value: 80, name: 'semanya' },
  { symbol: '፺', value: 90, name: 'zetena' },
  { symbol: '፻', value: 100, name: 'meto' }
];

export const vocabularyWords = [
  { id: 1, word: 'አባ', translation: 'Father', characters: ['አ', 'ባ'], pronunciation: 'abba' },
  { id: 2, word: 'ልጅ', translation: 'Child', characters: ['ል', 'ጅ'], pronunciation: 'lij' },
  { id: 3, word: 'ቤት', translation: 'House', characters: ['ቤ', 'ት'], pronunciation: 'bet' },
  { id: 4, word: 'እንቁላል', translation: 'Egg', characters: ['እ', 'ን', 'ቁ', 'ላ', 'ል'], pronunciation: 'enqulal' },
  { id: 5, word: 'ድመት', translation: 'Cat', characters: ['ድ', 'መ', 'ት'], pronunciation: 'dimet' },
  { id: 6, word: 'እህል', translation: 'Grain', characters: ['እ', 'ህ', 'ል'], pronunciation: 'ehil' },
  { id: 7, word: 'ውሃ', translation: 'Water', characters: ['ው', 'ሃ'], pronunciation: 'wuha' },
  { id: 8, word: 'እንቅልፍ', translation: 'Sleep', characters: ['እ', 'ን', 'ቅ', 'ል', 'ፍ'], pronunciation: 'enqilf' },
  { id: 9, word: 'መኪና', translation: 'Car', characters: ['መ', 'ኪ', 'ና'], pronunciation: 'mekina' },
  { id: 10, word: 'ገነት', translation: 'Garden', characters: ['ገ', 'ነ', 'ት'], pronunciation: 'genet' },
  { id: 11, word: 'እርስዎ', translation: 'You (Formal)', characters: ['እ', 'ር', 'ስ', 'ዎ'], pronunciation: 'erswo' },
  { id: 12, word: 'እኔ', translation: 'I / Me', characters: ['እ', 'ኔ'], pronunciation: 'ene' },
  { id: 13, word: 'እኛ', translation: 'We', characters: ['እ', 'ኛ'], pronunciation: 'enya' },
  { id: 14, word: 'አንተ', translation: 'You (Male)', characters: ['አ', 'ን', 'ተ'], pronunciation: 'ante' },
  { id: 15, word: 'አንቺ', translation: 'You (Female)', characters: ['አ', 'ን', 'ቺ'], pronunciation: 'anchi' },
  { id: 16, word: 'እሱ', translation: 'He', characters: ['እ', 'ሱ'], pronunciation: 'esu' }
];

export const orderNames = [
  'Ge\'ez (1st Order)',
  'Ka\'eb (2nd Order)',
  'Salis (3rd Order)',
  'Rabe (4th Order)',
  'Hamis (5th Order)',
  'Sades (6th Order)',
  'Sabe (7th Order)'
];